import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../services/partner.service';
import { P } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-partner-detail-nav-header',
  templateUrl: './partner-detail-nav-header.component.html',
  styleUrls: ['./partner-detail-nav-header.component.scss']
})
export class PartnerDetailNavHeaderComponent implements OnInit {

  showProDetails: boolean;
  showShows: boolean;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {
    this.setShowProDetails();

    this.partnerService.showProDetails$.subscribe((x) => {
      this.showProDetails = x;
    });

    this.partnerService.showShows$.subscribe((x) => {
      this.showShows = x;
    });

  }

  setShowProDetails() {
    this.partnerService.setShowProDetails(true);
    this.partnerService.setShowShows(false);
  }

  setShowShows() {
    this.partnerService.setShowShows(true);
    this.partnerService.setShowProDetails(false);
  }

}
